import { inject, Injectable } from '@angular/core';
import { IPendingRequest } from '../models/pending-request.model';
import { filter, Observable, switchMap } from 'rxjs';
import { manageRequestConst } from '../manage-request.const';
import { HttpHeaders } from '@angular/common/http';
import { BaseHttpService } from '../../services/common/base.http.service';
import { LoggedInUserService } from '../../services/common/logged-in-user.service';
import { IBankAccount } from '../models/bank-account.model';
import { ISendToBank } from '../models/send-to-bank.model';
import { IPaymentFile } from '../models/payment-file.model';
import { IPaymentFileData } from '../models/payment-file-data.model';
import { IOpenRequest } from '../models/open-request.model';

@Injectable({
  providedIn: 'root'
})
export class PendingRequestsService {
  baseHttpService = inject(BaseHttpService);
  loggedInUserService = inject(LoggedInUserService);
  userEmail: string;
  
  getPendingRequests(): Observable<IPendingRequest[]> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.loggedInUserService.currentUser$
      .pipe(
        filter(data => data !== null),
        switchMap(data => {
          return this.baseHttpService.get<IPendingRequest[]>(manageRequestConst.pendingRequests + data.userEmail, { headers: headers });
        })
      );
  }

  getReviewedRequests(): Observable<IPendingRequest[]> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.loggedInUserService.currentUser$
      .pipe(
        filter(data => data !== null),
        switchMap(data => {
          return this.baseHttpService.get<IPendingRequest[]>(manageRequestConst.reviewedRequests + data.userEmail, { headers: headers });
        })
      );
  }

  getOpenRequests(): Observable<IOpenRequest[]> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.loggedInUserService.currentUser$
      .pipe(
        filter(data => data !== null),
        switchMap(data => {
          return this.baseHttpService.get<IOpenRequest[]>(manageRequestConst.openRequests + data.userEmail, { headers: headers });
        })
      );
  }

  getBankAccount(employeeNo: number): Observable<IBankAccount> {
    return this.baseHttpService.get<IBankAccount>(manageRequestConst.bankAccount + employeeNo);
  }

  getPaymentFileData(params: number[]): Observable<IPaymentFileData[]> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.loggedInUserService.currentUser$
      .pipe(
        filter(data => data !== null),
        switchMap(data => {
          const paymentFile: IPaymentFile = {
            requestNumbers: params,
            userEmail: data.userEmail,
            userName: data.userName
          }
          return this.baseHttpService.post<IPaymentFileData[]>(manageRequestConst.paymentFile, paymentFile, { headers: headers });
        })
      );
  }

  sendRequestToBank(params: ISendToBank): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.baseHttpService.post(manageRequestConst.sendToBank, params, { headers: headers });
  }

  validateBankRequest(params: ISendToBank): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.baseHttpService.post(manageRequestConst.validateBankRequest, params, { headers: headers });
  }
}